import { Routes } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
import { AuthGuard } from 'src/app/core/guards/auth-guard.service';
import { AdminGuard } from 'src/app/core/guards/admin-guard.service';
const ɵ0 = () => import("./pages/users/sign-in/sign-in.module.ngfactory").then((m) => m.SignInModuleNgFactory), ɵ1 = () => import("./pages/users/sign-in-tecnico/sign-in-tecnico.module.ngfactory").then((m) => m.SignInTecnicoModuleNgFactory), ɵ2 = () => import("./pages/users/change-password/change-password.module.ngfactory").then((m) => m.ChangePasswordModuleNgFactory), ɵ3 = () => import("./pages/users/two-factor/two-factor.module.ngfactory").then((m) => m.TwoFactorModuleNgFactory), ɵ4 = () => import("./pages/users/confirm-email/confirm-email.module.ngfactory").then((m) => m.ConfirmEmailModuleNgFactory), ɵ5 = () => import("./pages/users/sign-in-tecnico/sign-in-tecnico.module.ngfactory").then((m) => m.SignInTecnicoModuleNgFactory), ɵ6 = () => import("./pages/users/forgot-password/forgot-password.module.ngfactory").then((m) => m.ForgotPasswordModuleNgFactory), ɵ7 = () => import("./pages/users/register/register.module.ngfactory").then((m) => m.RegisterModuleNgFactory), ɵ8 = () => import("./pages/sub-category/sub-category.module.ngfactory").then((m) => m.SubCategoryModuleNgFactory), ɵ9 = () => import("./pages/sub-category/sub-category.module.ngfactory").then((m) => m.SubCategoryModuleNgFactory), ɵ10 = () => import("./pages/transaction-type-detail/transaction-type-detail.module.ngfactory").then((m) => m.TransactionTypeDetailModuleNgFactory), ɵ11 = () => import("./pages/profile-picker/profile-picker.module.ngfactory").then((m) => m.ProfilePickerModuleNgFactory), ɵ12 = () => import("./pages/transaction/transaction-management.module.ngfactory").then((m) => m.TransactionManagementModuleNgFactory), ɵ13 = () => import("./pages/transaction-admin/transaction-admin-management.module.ngfactory").then((m) => m.TransactionAdminManagementModuleNgFactory), ɵ14 = () => import("./pages/transaction-receipt/transaction-receipt.module.ngfactory").then((m) => m.TransactionReceiptModuleNgFactory), ɵ15 = () => import("./pages/transaction-plan-receipt/transaction-plan-receipt.module.ngfactory").then((m) => m.TransactionPlanReceiptModuleNgFactory), ɵ16 = () => import("./pages/account/account.module.ngfactory").then((m) => m.AccountModuleNgFactory), ɵ17 = () => import("./pages/credit/credit.module.ngfactory").then((m) => m.CreditModuleNgFactory), ɵ18 = () => import("./pages/shared/privacy/privacy.module.ngfactory").then((m) => m.PrivacyModuleNgFactory), ɵ19 = () => import("./pages/shared/terms/terms.module.ngfactory").then((m) => m.TermsModuleNgFactory), ɵ20 = () => import("./pages/shared/transaction-supplementary-documents-list/transaction-supplementary-documents-list.module.ngfactory").then((m) => m.TransactionSupplementaryDocumentsListModuleNgFactory), ɵ21 = () => import("./pages/medical-certificate/medical-certificate.module.ngfactory").then((m) => m.MedicalCertificateModuleNgFactory), ɵ22 = () => import("./pages/doctor/doctor.module.ngfactory").then((m) => m.DoctorModuleNgFactory), ɵ23 = () => import("./pages/my-request/my-request.module.ngfactory").then((m) => m.MyRequestModuleNgFactory), ɵ24 = () => import("./pages/licesing-discipline-form/licesing-discipline-form.module.ngfactory").then((m) => m.LicesingDisciplineFormModuleNgFactory), ɵ25 = () => import("./pages/certificate-qr-validation/certificate-qr-validation.module.ngfactory")
    .then((m) => m.CertificateQrValidationModuleNgFactory), ɵ26 = () => import("./pages/user-process-qr-validation/user-process-qr-validation.module.ngfactory")
    .then((m) => m.UserProcessQrValidationModuleNgFactory), ɵ27 = () => import("./pages/under-construction/under-construction.module.ngfactory")
    .then((m) => m.UnderConstructionModuleNgFactory);
const routes = [
    {
        path: 'welcome',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: ɵ0,
    },
    {
        path: 'login-admin',
        loadChildren: ɵ1,
    },
    {
        path: 'changePassword',
        loadChildren: ɵ2,
    },
    {
        path: 'two-factor',
        loadChildren: ɵ3,
    },
    {
        path: 'confirm-email',
        loadChildren: ɵ4,
    },
    {
        path: 'login-tecnico',
        loadChildren: ɵ5,
    },
    {
        path: 'forgotPassword',
        loadChildren: ɵ6,
    },
    {
        path: 'register',
        loadChildren: ɵ7,
    },
    {
        path: 'available-transactions',
        loadChildren: ɵ8,
    },
    {
        path: '',
        loadChildren: ɵ9,
    },
    {
        path: 'transaction-type',
        loadChildren: ɵ10,
    },
    {
        path: 'transaction-type/profile',
        loadChildren: ɵ11,
    },
    {
        path: 'transactions',
        loadChildren: ɵ12,
    },
    {
        path: 'transactions-admin',
        loadChildren: ɵ13,
    },
    {
        path: 'transaction-receipt',
        loadChildren: ɵ14,
    },
    {
        path: 'transaction-plan-receipt',
        loadChildren: ɵ15,
    },
    {
        path: 'account',
        loadChildren: ɵ16,
    },
    {
        path: 'credit-purchase',
        loadChildren: ɵ17,
    },
    {
        path: 'privacy',
        loadChildren: ɵ18,
    },
    {
        path: 'terms',
        loadChildren: ɵ19,
    },
    {
        path: 'user-process-document-request/requestId/:id',
        loadChildren: ɵ20,
    },
    // {
    //   path: '',
    //   loadChildren: () =>
    //     import('src/app/pages/category-detail/category-detail.module').then((m) => m.CategoryDetailModule),
    // },
    /*   {
        path: 'certifications',
        loadChildren: () =>
          import('./pages/certifications/certification.module').then((m) => m.CertificationsModule),
      },   */
    {
        path: 'medical-certificates',
        loadChildren: ɵ21,
    },
    {
        path: 'doctor',
        loadChildren: ɵ22,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'my-request',
        loadChildren: ɵ23,
    },
    {
        path: 'medical-profile',
        loadChildren: ɵ24,
    },
    {
        path: 'qrcode/validateCertificate/:id',
        loadChildren: ɵ25,
    },
    {
        path: 'qrcode/:id',
        loadChildren: ɵ26,
    },
    {
        path: 'under-construction',
        loadChildren: ɵ27,
    },
    { path: '**', component: PageNotFoundComponent },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19, ɵ20, ɵ21, ɵ22, ɵ23, ɵ24, ɵ25, ɵ26, ɵ27 };
